export enum ShowBreadCrumbsEnum {
  NEVER = 'never',
  VISIBLE = 'visible',
  HIDDEN = 'hidden',
  ALL = 'all',
}

export enum SaveFiltersSorterEnum {
  NEVER = 'never',
  SESSION_STORAGE = 'session_storage',
  LOCAL_STORAGE = 'local_storage',
}

export interface TableColumn {
  name?: string;
  dataIndex: string;
  visibility?: boolean;
  canChangeVisibilty?: boolean;
  pin?: string;
  canChangePin?: boolean;
  canMove?: boolean;
}

export interface TableSettings {
  version: 'v1';
  tableKey?: string;
  hideDisabledColumns: boolean;
  saveFiltersSorter: SaveFiltersSorterEnum;
  showBreadcrumbs: ShowBreadCrumbsEnum;
  columns: TableColumn[];
}
